//组件对象，大写
import sideTableSubmitForm from './sideTableSubmitForm.vue'
export default sideTableSubmitForm
